export default "__VITE_ASSET__3D1lOvpd__"